import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { AbstractControl, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatAutocompleteModule, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { ValidationModalComponent } from 'src/app/shared/validation-modal/validation-modal.component';
import { delay, take } from 'rxjs';
import { AgentsService } from 'src/app/core/services/agents.service';
import { DirectionService } from 'src/app/core/services/direction.service';
import { FonctionnelService } from 'src/app/core/services/fonctionnel.service';

@Component({
  selector: 'app-edit-agent',
  imports: [
    CommonModule,
    MatIconModule,
    MatCardModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatDividerModule,
    MatInputModule,
    MatDialogModule,
    MatRadioModule,
    MatCheckboxModule,
    MatAutocompleteModule
  ],
  templateUrl: './edit-agent.component.html',
  styleUrls: ['./edit-agent.component.scss']
})
export class EditAgentComponent implements OnInit {
  editForm: FormGroup;
  autoComplete: MatAutocompleteTrigger;
  directionList: any[] = [];
  filtredDirectionList: any = [];
  servicelList: any[] = [];
  filteredlistService: any = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<EditAgentComponent>,
    private readonly formBuilder: FormBuilder,
    public dialog: MatDialog,
    private readonly directionService: DirectionService,
    private readonly agentService: AgentsService,
    private readonly fonctionnelService: FonctionnelService
  ) {
    this.editForm = this.formBuilder.group({
      nom: [this.data.rowElement.nom, [Validators.required]],
      prenom: [this.data.rowElement.prenom, [Validators.required]],
      email: [
        this.data.rowElement.email,
        [Validators.required, Validators.email, Validators.pattern('^[a-z0-9-zA-Z._%+-]+@[a-z0-9-zA-Z.-]+\\.[a-zA-Z]{2,4}$')]
      ],
      login: [this.data.rowElement.login, [Validators.required]],
      direction: [
        this.data.rowElement.direction,
        this.data.rowElement.direction ? [] : [Validators.required, this.validateDirection.bind(this)]
      ],
      service: [
        this.data.rowElement.serviceFonctionnel,
        this.data.rowElement.serviceFonctionnel ? [] : [Validators.required, this.validateService.bind(this)]
      ],
      actif: [this.data.rowElement.actif],
      verrouAdmin: [this.data.rowElement.verrouAdmin]
    });
  }

  ngOnInit() {
    this.editForm.valueChanges.subscribe(() => {
      this.editForm.updateValueAndValidity();
    });
    this.loadDirectionList();
    this.loadListService();
  }
  onClose() {
    this.dialogRef.close();
  }

  validateDirection(control: AbstractControl) {
    if (control.value) {
      const direction = this.directionList.find((item) => item.libelle === control.value.libelle);
      return direction ? null : { invalidDirection: true };
    }
    return null;
  }

  validateService(control: AbstractControl) {
    if (control.value) {
      const service = this.servicelList.find((item) => item.libelle === control.value.libelle);
      return service ? null : { invalidService: true };
    }
    return null;
  }
  saveAgent() {
    if (this.editForm.valid) {
      const id = this.data.id;
      const data = this.editForm.value;
      this.data.rowElement.nom = data.nom;
      this.data.rowElement.prenom = data.prenom;
      this.data.rowElement.email = data.email;
      this.data.rowElement.login = data.login;
      this.data.rowElement.direction = data.direction;
      this.data.rowElement.serviceFonctionnel = data.service;
      this.data.rowElement.actif = data.actif;
      this.data.rowElement.verrouAdmin = data.verrouAdmin;

      this.agentService
        .ModifierAgent(this.data.rowElement, id)
        .pipe(delay(1000))
        .subscribe({
          next: (result) => {
            this.dialog
              .open(ValidationModalComponent, {
                width: '600px',
                data: {
                  title: 'Confirmation',
                  content: 'L’agent a été modifié avec succès.'
                }
              })
              .afterClosed()
              .subscribe((action) => {
                if (action) {
                  this.dialogRef.close();
                }
              });
          }
        });
    } else {
    }
  }
  loadDirectionList() {
    this.directionService
      .getAllDirectionsDemandes()
      .pipe(take(1))
      .subscribe((data) => {
        if (data) {
          this.filtredDirectionList = data.filter((o: any) => {
            if (o.libelle !== '') {
              return o;
            }
          });
          console.warn(this.filtredDirectionList);

          this.directionList = [...this.filtredDirectionList];
        }
      });
  }
  loadListService() {
    this.fonctionnelService
      .getAllServicesDemandes()
      .pipe(take(1))
      .subscribe((data) => {
        if (data) {
          this.filteredlistService = data.filter((o: any) => {
            if (o.libelle !== '') {
              return o;
            }
          });

          this.servicelList = this.filteredlistService;
        }
      });
  }

  directionFilter(event: any): void {
    const value = event.target.value;
    if (typeof value !== 'string') {
      this.directionList = [];
      return;
    }
    const filterValue = value.toLowerCase().split(' ').join('');
    this.directionList = this.filtredDirectionList.filter((item: any) =>
      item.libelle.toLowerCase().split(' ').join('').includes(filterValue)
    );
  }
  effaceDirectionFiltre(event: any, controlName: string) {
    event.stopPropagation();

    if (controlName != undefined && controlName != '') {
      this.editForm.controls[controlName].setValue('');
      this.loadDirectionList();
    }
  }
  directionDisplayFn(direction?: any): string {
    return direction ? direction.libelle : '';
  }

  serviceFilter(event: any): void {
    const value = event.target.value;
    if (typeof value !== 'string') {
      this.servicelList = [];
      return;
    }
    const filterValue = value.toLowerCase().split(' ').join('');
    this.servicelList = this.filteredlistService.filter((element: any) =>
      element.libelle.toLowerCase().split(' ').join('').includes(filterValue)
    );
  }
  effaceFiltreService(event: any, controlName: string) {
    event.stopPropagation();

    if (controlName != undefined && controlName != '') {
      this.editForm.controls[controlName].setValue('');
      this.loadListService();
    }
  }
  serviceDisplayFn(element?: any): string {
    return element ? element.libelle : '';
  }
}
